import { useEffect } from 'react';
import InnerLayout from '../components/InnerLayout';

export default function Contacto() {
  useEffect(() => { document.title = 'Contacto — Sttora'; }, []);
  return (
    <InnerLayout titleFirst="Casa" titleAccent="Matriz" subtitle="Información de contacto directo con el equipo corporativo de Sttora." breadcrumb="Contacto">
      <div className="section-label">Información de Contacto</div>
      <div className="info-block">
        <div className="info-item"><div className="info-label">Dirección</div><div className="info-value">Av. Corporativa 1000, Piso 12<br />Ciudad de México, México</div></div>
        <div className="info-item"><div className="info-label">Email Corporativo</div><div className="info-value"><a href="mailto:contacto@sttora.com">contacto@sttora.com</a></div></div>
        <div className="info-item"><div className="info-label">Legal</div><div className="info-value"><a href="mailto:legal@sttora.com">legal@sttora.com</a></div></div>
      </div>
      <hr className="section-divider" />
      <div className="section-label">Envíanos un Mensaje</div>
      <form className="contact-form" onSubmit={e => e.preventDefault()}>
        <div className="form-row">
          <div className="form-group"><label className="form-label">Nombre</label><input className="form-input" type="text" placeholder="Tu nombre" /></div>
          <div className="form-group"><label className="form-label">Apellido</label><input className="form-input" type="text" placeholder="Tu apellido" /></div>
        </div>
        <div className="form-group"><label className="form-label">Correo Electrónico</label><input className="form-input" type="email" placeholder="correo@ejemplo.com" /></div>
        <div className="form-group"><label className="form-label">Asunto</label><input className="form-input" type="text" placeholder="¿En qué podemos ayudarte?" /></div>
        <div className="form-group"><label className="form-label">Mensaje</label><textarea className="form-textarea" placeholder="Escribe tu mensaje aquí..." /></div>
        <button type="submit" className="btn btn-primary">Enviar Mensaje</button>
      </form>
    </InnerLayout>
  );
}
